import { CommonModule } from '@angular/common';
import { FormlyDatePickerBootstrapComponent } from './formly-types/formly-date-picker-bootstrap/formly-date-picker-bootstrap.component';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyFieldsetWrapper } from './formly-types/formly-wrappers/FormlyFiledsetWrapper.component';
import { FormlyLabelWrapper } from './formly-types/formly-wrappers/FormlyLabelWrapper.component';
import { RepeatTypeComponent } from './formly-types/repeat-type.formly.component';
import { FormlyFieldTypeahead } from './formly-types/typeahead.type.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { validateRequired, validateMinLength, validateMaxLength, validateMin, validateMax, IpValidatorMessage, IpValidator } from './validators';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { TestTinyComponent } from './test-tiny/test-tiny.component';
import { FormlyTinyMceTypeComponent } from './formly-types/formly-tinymce/formly-tinymce.type.component';
import { PanelWrapperComponent } from './formly-types/formly-wrappers/panel-wrapper.component';
import { FormlySelectModule } from '@ngx-formly/core/select';
import { FormlyMultilangComponent } from './formly-types/formly-multilang/formly-multilang.component';
import { MODULES_NB } from '@hm_app/@core/utils/nb_modules';
import { FormlyMultilangQuestionAnswerComponent } from './formly-types/formly-multilang-question-answer/formly-multilang-question-answer.component';
import { FormlyTabsComponent } from './formly-types/formly-tabs/formly-tabs.component';
import { FormlySelectComponent } from './formly-types/formly-select/formly-select.component';


@NgModule({
  declarations: [
    RepeatTypeComponent,
    FormlyDatePickerBootstrapComponent,
    FormlyFieldTypeahead,
    FormlyTinyMceTypeComponent,
    TestTinyComponent,
    FormlyMultilangComponent,
    FormlyMultilangQuestionAnswerComponent,
    FormlyTabsComponent,
    FormlySelectComponent,

  ],
  exports: [
    RepeatTypeComponent,
    FormlyDatePickerBootstrapComponent,
    FormlyFieldTypeahead,
    FormlyTinyMceTypeComponent,
    TestTinyComponent,
    FormlyModule,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgSelectModule,
    EditorModule,
    ...MODULES_NB,
    FormlyModule.forRoot({
      validationMessages: [
        { name: 'required', message: validateRequired },
        { name: 'minlength', message: validateMinLength },
        { name: 'maxlength', message: validateMaxLength },
        { name: 'min', message: validateMin },
        { name: 'max', message: validateMax },
        // Custom validation message
        { name: 'ip', message: IpValidatorMessage },
      ],
      validators: [
        { name: 'ip', validation: IpValidator },
      ],
      types: [
        { name: 'typeahead', component: FormlyFieldTypeahead },
        { name: 'repeat', component: RepeatTypeComponent },
        {
          name: 'datepicker',
          component: FormlyDatePickerBootstrapComponent,
          wrappers: ['label', 'fieldset'],
        },
        { name: 'tinymce', component: FormlyTinyMceTypeComponent },
        { name: 'richtext', component: FormlyTinyMceTypeComponent },
        { name: 'htmltext', component: FormlyTinyMceTypeComponent },
        { name: 'multilang', component: FormlyMultilangComponent },
        { name: 'multilang-question-answer', component: FormlyMultilangQuestionAnswerComponent },
        { name: 'tabs', component: FormlyTabsComponent },
        { name: 'select-autocomplete', component: FormlySelectComponent }
      ],
      wrappers: [
        { name: 'label', component: FormlyLabelWrapper },
        { name: 'fieldset', component: FormlyFieldsetWrapper },
        { name: 'panel', component: PanelWrapperComponent },
      ],
    }),
    FormlyBootstrapModule,
    FormlySelectModule,
  ],
  providers: [
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
  ],

})
export class NtfFormlyModule { }
